import {deleteNote, saveNote, updateNote} from "../../services/apollo/notes";

export default {
  namespaced: true,
  actions: {
    saveNote({commit}, {callSid, note}) {
      return saveNote(callSid, note)
        .then((noteres) => {
          commit('setNote', {callSid, note: noteres})
        })
    },
    updateNote({commit}, {callSid, note}) {
      return updateNote(callSid, note)
        .then((noteres) => {
          commit('setNote', {callSid, note: noteres})
        })
    },
    saveNoteInSessionLog({commit}, {callSid, note, id}) {
      return saveNote(callSid, note)
        .then((note) => {
          commit('sessions/addNote', {id, note}, {root: true})
        })
    },
    updateNoteInSessionLog({commit}, {callSid, note, id}) {
      return updateNote(callSid, note)
        .then((note) => {
          commit('sessions/updateNote', {id, note}, {root: true})
        })
    },

    deleteNoteInSessionLog({commit}, {noteId, id}) {
      return deleteNote(noteId)
        .then(() => {
          commit('sessions/removeNote', {id, noteId}, {root: true})
        })
    }
  },
  mutations: {
    setCurrentNote(state, {callSid}) {
      state.currentNote = callSid;
    },
    setNote(state, {callSid, note}) {
      state.notesMap = {
        ...state.notesMap,
        [callSid]: note
      }
    }
  },
  state: {
    currentNote: null,
    activeSessionNotes: {},
    notesMap: {}
  }
}
